import { FavoriteCuisines } from "@/clients/models/FavoriteCuisines";
import { FavoriteCuisinesService } from "@/clients/services/FavoriteCuisinesService";
import { guardGetUserFromLocalStorage } from "@/utils/request";
import { useMutation } from "@tanstack/react-query";

export const useUpdateFavoriteCuisines = () => {
  const { mutate, isPending, isError, error } = useMutation({
    mutationFn: async (favoriteCuisines: FavoriteCuisines) => {
      const user = guardGetUserFromLocalStorage();
      const { data } =
        await FavoriteCuisinesService.updateFavoriteCuisinesApiV1FavoriteCuisinesPut(
          user.id,
          favoriteCuisines,
        );
      if (error) {
        throw new Error(error.message);
      }
      return data;
    },
  });
  return {
    updateFavoriteCuisines: mutate,
    isUpdating: isPending,
    isError,
    error,
  };
};
